import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { DropdownButton, Dropdown } from 'react-bootstrap'
import withRouter from '../../../../private-routers/withRouter'
import { truncateString } from '../../../../utils'
import Accordion from '../../../Common/Accordion'
import ToggleAccordion from '../../../Common/ToggleAccordion'
import ContinueActiveButton from '../ContinueActiveButton'
import './Unlocked.scss'

const businessProcessImg = 'data:image/jpg;base64, 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'

export const seeEditScreen = (processId) => {
  this.props.navigate(`/dpia/edit/${ processId }`)
}

export const seeQuestions = (assessmentId) => {
  this.props.navigate(`/dpia/assessment/${ assessmentId }`)
}

export const getAnswered = (assessment) => {
  if (!assessment) return

  const stats = assessment.questionsStateStats
  const answered = stats.SUBMITTED_NO || 0
  const notapplicable = stats.QUESTIONNAIRE_SKIPPED_NO || 0
  return answered + notapplicable
}

export const getTotal = (assessment) => {
  if (!assessment) return

  const stats = assessment.questionsStateStats
  const answered = stats.SUBMITTED_NO || 0
  const unanswered = stats.UNANSWERED_NO || 0
  const skipped = stats.USER_SKIPPED_NO || 0
  const notapplicable = stats.QUESTIONNAIRE_SKIPPED_NO || 0

  return answered + unanswered + skipped + notapplicable
}

export const getLastNotCompletedAssessment = (process, type) => {
  const { assessments } = process
  let assesment
  if (type === 'PIA_QUESTIONNAIRE') {
    assesment = assessments.find((a) => a.type === 'PIA_QUESTIONNAIRE')
  } else {
    let filteredAssessments = assessments.filter(() => true)
    filteredAssessments = filteredAssessments.sort((a, b) => a.id - b.id)
    assesment = filteredAssessments[filteredAssessments.length - 1]
  }

  return assesment
}

export let Unlocked = ({ accordion, content, index, process, type, processStatus, dpiaQuestionnaireType, toggleAccordion, usersList, chosenView, user, teams }) => {
  const [image, setImage] = useState(undefined)
  const assessment = getLastNotCompletedAssessment(process, type)
  const total = getTotal(assessment)
  const answered = getAnswered(assessment)
  let status = 'Incomplete'

  if (assessment.status === 'COMPLETED') {
    status = 'Completed'
  }

  if (chosenView !== 'table') {
    if (image === undefined) {
      if (process && process.assignedToUserID) {
        const user = usersList.filter((user) => user.id === process.assignedToUserID)[0]
        if (user) {
          setImage(businessProcessImg)
        }
      }
      else if (process && process.assignedToTeamID) {
        setImage(businessProcessImg)
      } else if (process && !process.assignedToTeamID && !process.assignedToUserID) {
        if (user) {
          setImage(businessProcessImg)
        }
      }
    }

  }

  const team = process.assignedToTeam

  let userName = ''
  if (usersList && process.assignedToUserID) {
    usersList.map((user) => {
      if (user.id === process.assignedToUserID) {
        userName = user.name
      }
      return 0
    })
  }

  if (chosenView === 'table') {
    return (
      <tr>
        <td style={{ textAlign: 'center' }}>{assessment.type === 'PIA_QUESTIONNAIRE' ? 'PIA' : assessment.type === 'DPIA_QUESTIONNAIRE' ? 'DPIA' : ''}</td>
        <td style={{ textAlign: 'center' }}>{process.dpiaQuestionnaireType === 'DATA_PROCESSOR_DPIA' ? 'DP' : 'DC'}</td>
        <td className="collectionList__cellTitle"> {truncateString(process.title, 55)}</td>
        <td className="collectionList__cellSmall">{assessment.status}</td>
        <td className="collectionList__cellSmall"
          style={{ textAlign: 'right' }}>{`${ answered === total ? '100' : (answered * 100 / total).toFixed(0) }%`}</td>
        <td className="collectionList__cellSmall" style={{ textAlign: 'right' }}>{`${ answered }/${ total }`}</td>
        <td className="collectionList__cellSmall actionsDotsCell" style={{ textAlign: 'center' }}>
          <DropdownButton
            title="..."
            noCaret
            id={`dropdown-${ process.id }`}
          >
            <Dropdown.Item onClick={() => {
              this.props.navigate(`/dpia/edit/${ process.id }`)
            }}>Edit</Dropdown.Item>
            <Dropdown.Item onClick={seeQuestions.bind(this, assessment.id)}>Continue</Dropdown.Item>
            <Dropdown.Item>Delete</Dropdown.Item>
          </DropdownButton>
        </td>
      </tr>
    )
  }
  return (
    <div className="unlockedDashboard-wrapper">
      <Accordion
        opened={accordion[index]}
        header={
          <div className={accordion[index] ? 'unlockedDashboard-itemHeaderOpened' : 'unlockedDashboard-itemHeader'}
            onClick={toggleAccordion.bind(this, accordion, index)}>
            <div className="unlockedDashboard-infoContainer">
              <div className="unlockedDashboard-name">
                {type === undefined ? (

                  <span>{type}</span>
                ) : (<span>{type} - </span>)
                }

                {truncateString(process.title, 55)}
                <h2 className="unlockedDashboard__questionGroup">{dpiaQuestionnaireType}</h2>
              </div>
              {
                assessment &&
                    <div className="unlockedDashboard__lastAssessmentInfo">
                      {`${ status }, ${ answered }/${ total }`} <br/>
                      <span>{team ? team : (userName ?
                        <p title={userName}>{(userName).substring(0, 48)}</p> : 'unassigned')}</span>
                    </div>
              }
              {assessment &&
                  <div className="unlockedDashboard__icon">
                    <div className="unlocked-userIcon">
                      <img className="dashboardIconImage" src={image} alt=""/>
                    </div>
                  </div>
              }

              {processStatus === 'ACTIVE' &&
                  <ContinueActiveButton
                    user={user}
                    teams={teams}
                    assessment={assessment}
                    process={process}
                    onClick={seeQuestions.bind(this)}
                  />
              }
            </div>

            <ToggleAccordion
              oppened={accordion[index]}
              index={index}
              toggleAccordion={toggleAccordion.bind(this, accordion, index)}
            />
          </div>
        }
        content={content}
      />
    </div>
  )
}
Unlocked = withRouter(Unlocked)
Unlocked.propTypes = {
  accordion: PropTypes.object.isRequired,
  content: PropTypes.object.isRequired,
  processStatus: PropTypes.string.isRequired,
  dpiaQuestionnaireType: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  process: PropTypes.object.isRequired,
  toggleAccordion: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired
}

export default Unlocked
